import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Assuming these are local utility files, you may need to
// define interfaces for them if they aren't already typed.
import Backend from './utils/Backend';
import SessionStoreManager from './utils/SessionStoreManager';

const RESOURCE_NAME: string = 'Web-Advisory-Tablet';

// 1. Extend the i18next type definition if you need the custom '.locale' property
// because standard i18next doesn't have a 'locale' property on its base object.
declare module 'i18next' {
    interface i18n {
        locale?: string;
    }
}

i18n
    // load translation using /resourcesets/{name}/?language={language}
    .use(Backend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    .init({
        fallbackLng: 'de',
        keySeparator: '_',
        react: {
            useSuspense: true,
        },
        backend: {
            resourceName: RESOURCE_NAME,
            SaveManager: SessionStoreManager,
        },
        // debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

// Custom property assignment
i18n.locale = 'CH';

export default i18n;
